export const COUNTRY_COLORS = {
    "Other Hispanic or Latino": "#a7e72c",
    "Other Subsaharan African": "#778ced",
    "Pennsylvania German": "#44d739",
    "Nigerian": "#0a02d6",
    "Cherokee": "#a645cc",
    "Paiute": "#b7a48b",
    "Yugoslavian": "#87b3d8",
    "Colombian": "#76f684",
    "Pima": "#8015af",
    "Yaqui": "#ad800d",
    "Cuban": "#14ace6",
    "Irish": "#c8ee2a",
    "Puget Sound Salish": "#af8bd5",
    "Eastern European": "#a8d87a",
    "Yuman": "#32f2e7",
    "Ukrainian": "#3b86ae",
    "Menominee": "#26f7dc",
    "Czech": "#287d7c",
    "Korean": "#655756",
    "Aleut": "#d3a517",
    "Lebanese": "#b51c91",
    "Syrian": "#89daa2",
    "Norwegian": "#68a3aa",
    "Native Hawaiian": "#fe2e4e",
    "Pakistani": "#37956d",
    "Blackfeet": "#e794d8",
    "Tohono O'Odham": "#377a49",
    "Nepalese": "#806173",
    "French (except Basque)": "#538ded",
    "Chilean": "#ee4b68",
    "English": "#f37f7c",
    "Lumbee": "#e20ed6",
    "Spaniard": "#86fd4d",
    "Greek": "#99ebf8",
    "Ute": "#802b5f",
    "West Indian": "#b71b28",
    "Scandinavian": "#a91c88",
    "Guatemalan": "#cf1590",
    "Other Asian specified": "#ac9584",
    "American": "#3de953",
    "Ecuadorian": "#3bdeb8",
    "Japanese": "#0e811e",
    "Israeli": "#9ddfcf",
    "Houma": "#a4a902",
    "Seminole": "#edd100",
    "Other Arab": "#3016e3",
    "Hungarian": "#843e40",
    "Northern European": "#5b803c",
    "Hopi": "#4f6bbd",
    "Apache": "#001445",
    "German": "#B32821",
    "Costa Rican": "#b0072f",
    "Somali": "#93c916",
    "Marshallese": "#34497e",
    "Iroquois": "#88d3bd",
    "Creek": "#8e6007",
    "Scottish": "#9db49d",
    "Peruvian": "#483350",
    "African": "#5ef016",
    "Ethiopian": "#90bd2a",
    "Puerto Rican": "#730956",
    "Bahamian": "#c8fad3",
    "Vietnamese": "#04c672",
    "Ugandan": "#4c605a",
    "Scotch-Irish": "#da459b",
    "South African": "#cf4ddf",
    "Portuguese": "#57d955",
    "Afghan": "#9d9df8",
    "Bangladeshi": "#f99669",
    "Mexican": "#7949d0",
    "Cheyenne": "#164f28",
    "Romanian": "#617a14",
    "Sioux": "#d7110d",
    "Cajun": "#f983d8",
    "Colville": "#b112ec",
    "Asian Indian": "#5d7616",
    "Tsimshian": "#9721ec",
    "Welsh": "#21cd1a",
    "Bolivian": "#c7e470",
    "Sudanese": "#b135f5",
    "Filipino": "#cf969b",
    "Iraqi": "#da6adb",
    "European": "#d14d28",
    "Swiss": "#4821c5",
    "Dutch": "#303d51",
    "British West Indian": "#01b3d3",
    "Laotian": "#6ebde9",
    "Canadian and French American Indian": "#790657",
    "Samoan": "#b60df5",
    "Spanish": "#5958c8",
    "Haitian": "#93c3e0",
    "Hmong": "#f1e50b",
    "Brazilian": "#8e804a",
    "African-American": "#a7c04d",
    "Thai": "#d6896e",
    "Burmese": "#378dc4",
    "Salvadoran": "#cf3c40",
    "British": "#a818cd",
    "Other Asian unspecified": "#469e78",
    "Russian": "#47a92b",
    "Polish": "#0c4c53",
    "Sierra Leonean": "#f91f3e",
    "Pueblo": "#904115",
    "Navajo": "#5d4393",
    "Venezuelan": "#6f3100",
    "Other South American": "#5fd86c",
    "Shoshone": "#76c836",
    "Arab": "#b2cde4",
    "Chickasaw": "#36131d",
    "Inupiat": "#0b4f5a",
    "Honduran": "#452964",
    "Other Micronesian": "#9d0cd2",
    "Trinidadian and Tobagonian": "#f3080c",
    "Liberian": "#33591b",
    "Danish": "#b8f978",
    "Jordanian": "#ad5ec4",
    "Turkish": "#27dddf",
    "American Indian tribe unspecified": "#634648",
    "Crow": "#716101",
    "Chippewa": "#c5932f",
    "Albanian": "#d70ece",
    "Assyrian/Chaldean/Syriac": "#4cca62",
    "Nicaraguan": "#19e97c",
    "American Indian or AK Native unspecified": "#5742ac",
    "Dominican (Dominican Republic)": "#e4e37c",
    "Tie": "#c041b9",
    "Argentinean": "#47aa78",
    "Cape Verdean": "#034951",
    "Armenian": "#f6264e",
    "French Canadian": "#3490ee",
    "Tlingit-Haida": "#2f32aa",
    "Other Central American": "#d6fd0f",
    "Kiowa": "#f024ac",
    "Guyanese": "#1327aa",
    "Choctaw": "#13735b",
    "Other American Indian tribe": "#162c6c",
    "Yakama": "#471547",
    "Egyptian": "#1e007b",
    "Alaskan Athabascan": "#eaf253",
    "Italian": "#FF7514",
    "Jamaican": "#6a4f11",
    "Arapaho": "#097df5",
    "Iranian": "#ba6408",
    "Swedish": "#4a2e42",
    "Cambodian": "#f6e894",
    "Finnish": "#cf8cf4",
    "Yup'ik": "#c08b05",
    "Moroccan": "#0dd742",
    "Chinese except Taiwanese": "#063971",
    "Palestinian": "#6a4f11",
    "Mexican American Indian": "#c08b05"
}